var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-start"},[_c('h4',[_c('i',{staticClass:"el-icon-sort-down"}),_vm._v(" メイン 開始 ")])])}]

export { render, staticRenderFns }